import { render, staticRenderFns } from "./EventUserTimesDialog.vue?vue&type=template&id=bf5e61b2&scoped=true&"
import script from "./EventUserTimesDialog.vue?vue&type=script&lang=js&"
export * from "./EventUserTimesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5e61b2",
  null
  
)

export default component.exports